import { getListOptions } from '@vlabs/shared/config/listOptions';
import { getSimilarityThresholds } from '@vlabs/shared/config/similarityThresholds';

import type { GetGroupedMatchesProps, GetGroupedMatchesReturn, ListsOption } from '../types';

export const getGroupedMatchesByListsAndExternalId = (
  { matches, uiDetectionURL }: GetGroupedMatchesProps,
): GetGroupedMatchesReturn => {
  const listOptions = getListOptions();
  const similarityThresholds = getSimilarityThresholds();

  const externalIdMatches = [];
  const listIdMatches = [];

  for (let index = 0; index < matches?.length; index++) {
    const face = matches[index]?.result?.[0]?.face;
    if (!face) break;

    const filters = matches[index]?.filters;
    const similarity = matches[index]?.result?.[0]?.similarity ?? 0;

    if (filters?.external_ids?.length && similarity < similarityThresholds.medium) {
      externalIdMatches.push({ ...face, similarity, uiDetectionURL });
    }

    if (filters?.list_id && similarity > similarityThresholds.medium) {
      const matchListLabel = listOptions.find((list: ListsOption) => list.value === filters.list_id).label;
      listIdMatches.push({
        ...face, similarity, matchListLabel, uiDetectionURL,
      });
    }
  }

  return {
    externalIdMatches,
    listIdMatches,
  };
};
